import PropTypes from 'prop-types';

const summaryContentType = PropTypes.arrayOf(PropTypes.exact({
  key: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  units: PropTypes.string,
  descriptor: PropTypes.string.isRequired,
  link: PropTypes.shape({
    children: PropTypes.node.isRequired,
    href: PropTypes.string.isRequired,
  }),
}));

export default summaryContentType;
